<template>
  <div v-if="modalIsOpened" class="fixed inset-0 w-full bg-black/30 z-50">
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
    >
      <div class="w-[100vw] max-w-[1000px] px-[20px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div class="mx-auto box-effect rounded-[10px] bg-white overflow-hidden">
          <div
            id="title"
            class="flex items-center justify-between py-[12px] pl-[20px] pr-[10px] bg-[#9B237B]"
          >
            <span class="PC_Body2-R text-[#FCFCFC]">
              ประวัติการโอนย้ายทรัพยากร
            </span>
            <CloseIcon
              @click="closeModal"
              class="w-[24px] h-[24px] bg-white text-[#9B237B] rounded-full cursor-pointer"
            />
          </div>
          <div
            class="max-h-[642px] flex flex-col p-[20px] gap-[10px] bg-[#FFF] overflow-auto"
          >
            <SearchBox
              :placeholder="'ค้นหา ชื่อทรัพยากร, ชื่อศูนย์พักพิง, ชื่อผู้กระทำ'"
              v-model="filter.search"
              @update:modelValue="
                () => {
                  (filter.page = ''), debouncedFetch();
                }
              "
            />
            <div class="flex items-center gap-[10px] flex-wrap">
              <!-- datePicker -->
              <DatePicker2
                :containerClass="'w-full sm:max-w-[257px]'"
                :modelValue="range"
                :placeholder="'เลือกช่วงเวลาที่กระทำ'"
                :isRange="true"
                @update:modelValue="(date) => selectRange(date)"
              />
              <!-- datePicker -->
              <SelectBoxComponent
                :selectContainerClass="'w-full sm:max-w-[164px]'"
                :inputId="'filter11'"
                :isFilter="true"
                :keyValue="'action'"
                :keyName="'name'"
                :options="Selector.sortOption1"
                :value="filter.sort"
                :placeholder="'แสดงรายการล่าสุด'"
                @update:modelValue="
                  (res) => {
                    filter.sort = res;
                    filter.page = '';
                    getData();
                  }
                "
              />
            </div>
            <div class="w-full">
              <!-- filter bar -->
              <div v-if="auth.hasRole([ROLES.admin])" class="overflow-scroll">
                <div class="min-w-[236px] flex items-center gap-[4px]">
                  <div
                    class="filterBar"
                    :class="{ active: filter.other_shelter == 0 }"
                    @click="
                      () => {
                        if (filter.other_shelter != 0) {
                          filter.other_shelter = 0;
                          filter.page = '';
                          getData();
                        }
                      }
                    "
                  >
                    <span class="PC_Body2-R"> ระหว่างศูนย์กลาง </span>
                  </div>
                  <div
                    class="filterBar"
                    :class="{ active: filter.other_shelter == 1 }"
                    @click="
                      () => {
                        if (filter.other_shelter != 1) {
                          filter.other_shelter = 1;
                          filter.page = '';
                          getData();
                        }
                      }
                    "
                  >
                    <span class="PC_Body2-R"> ระหว่างศูนย์อื่น </span>
                  </div>
                </div>
              </div>
              <!-- filter bar -->
              <!-- table -->
              <div
                v-if="transferProductLogs.length > 0"
                class="overflow-auto"
                :class="auth.hasRole([ROLES.admin]) ? 'h-[413px]' : 'h-[454px]'"
              >
                <table class="w-full min-w-[960px]">
                  <thead>
                    <tr>
                      <th
                        class="w-[10%] min-w-[92px] py-[16px] px-[10px] bg-[#9B237B] text-[#FFFFFF] text-left rounded-tl-[6px] border-r-[1px] border-solid border-[#FFFFFF]"
                      >
                        <span class="PC_Body2-R"> วันที่กระทำ </span>
                      </th>
                      <th
                        class="w-[5%] min-w-[54px] py-[16px] px-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]"
                      >
                        <span class="PC_Body2-R"> เวลา </span>
                      </th>
                      <th
                        class="w-[18%] py-[16px] px-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]"
                      >
                        <span class="PC_Body2-R"> ผู้โอน </span>
                      </th>
                      <th
                        class="w-[18%] py-[16px] px-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]"
                      >
                        <span class="PC_Body2-R"> ผู้รับ </span>
                      </th>
                      <th
                        class="w-[18%] py-[16px] px-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]"
                      >
                        <span class="PC_Body2-R"> ชื่อทรัพยากร </span>
                      </th>
                      <th
                        class="w-[12%] py-[16px] px-[10px] bg-[#9B237B] text-[#FFFFFF] text-left rounded-tr-[6px] border-r-[1px] border-solid border-[#FFFFFF]"
                      >
                        <span class="PC_Body2-R"> ยอดโอน </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(row, rowIndex) in transferProductLogs"
                      :key="rowIndex"
                      :class="[
                        '!border-none',
                        { 'bg-[#FBEFF8]': (rowIndex + 1) % 2 === 0 },
                      ]"
                    >
                      <td class="p-[10px] !border-none">
                        <span class="PC_Body2-R text-[#1F1D1F]">
                          {{ $formatDate2(row.created_at) }}
                        </span>
                      </td>
                      <td class="p-[10px] !border-none">
                        <span class="PC_Body2-R text-[#1F1D1F]">
                          {{ $formatTime1(row.created_at) }}
                        </span>
                      </td>
                      <td class="p-[10px] !border-none">
                        <span class="PC_Body2-R text-[#1F1D1F]">
                          {{ row.shelter_name_from }}
                        </span>
                      </td>
                      <td class="p-[10px] !border-none">
                        <span class="PC_Body2-R text-[#1F1D1F]">
                          {{ row.shelter_name_to }}
                        </span>
                      </td>
                      <td class="p-[10px] !border-none">
                        <span class="PC_Body2-R text-[#1F1D1F]">
                          {{ row.name }}
                        </span>
                      </td>
                      <td class="p-[10px] !border-none">
                        <div
                          class="flex items-center justify-between gap-[10px]"
                        >
                          <span class="PC_Body2-R text-[#1F1D1F]">
                            {{ $numberAndComma(row.detail.quantity) || 0 }}
                          </span>
                          <ButtonComponent
                            :icon="'InfoIcon'"
                            :bClass="'btn_shadow--2'"
                            @clicked="() => detail(row)"
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                v-if="transferProductLogs.length <= 0"
                class="flex flex-col items-center justify-center"
                :class="
                  auth.hasRole([ROLES.admin])
                    ? 'min-h-[413px]'
                    : 'min-h-[454px]'
                "
              >
                <NoInfoYetComponent :col="'10'" :icon="'ResourcesIcon'" />
              </div>
            </div>
            <!-- table -->
            <!-- pagination for modal -->
            <PaginationComponent
              :perPageId="'perpagemodal'"
              :items="pagination"
              @selectedPage="handlePage"
            />
            <!-- pagination for modal -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { Selector } from "@/components/Utilities/javascripts/constants";
import { useGlobals } from "@/components/Utilities/javascripts/useGlobals";
import { useProductStore } from "@/pinia/product";
import { useAuthStore } from "@/pinia/authStore";
import { storeToRefs } from "pinia";
import { debounce } from "lodash";
// โรล
import { ROLES } from "@/components/Utilities/javascripts/permissions";

const { $formatDate3 } = useGlobals();
const productStore = useProductStore();
const auth = useAuthStore();
const { allProductType, allProductClassifier, transferProductLogs } =
  storeToRefs(productStore);

const resourceTypeOption = computed(() => {
  return [
    {
      id: "",
      name: "แสดงทุกประเภท",
    },
    {
      id: "-1",
      name: "ไม่มีประเภท",
    },
    ...allProductType.value,
  ];
});

const resourceClassifierOption = computed(() => {
  return [
    {
      id: "",
      name: "แสดงทุกลักษณนาม",
    },
    {
      id: "-1",
      name: "ไม่มีลักษณนาม",
    },
    ...allProductClassifier.value,
  ];
});

const defaultFilter = {
  paginate: 10,
  page: "",
  search: "",
  unit_id: "",
  sort: "desc",
  start_date: "",
  end_date: "",
  other_shelter: 0,
};
const filter = ref({ ...defaultFilter });
const range = ref(null);
const pagination = ref(null);

const modalIsOpened = ref(false);
const emit = defineEmits(["open", "status", "detail"]);

const openModal = () => {
  range.value = null;
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";

  filter.value = { ...defaultFilter };

  getData();
};

const closeModal = () => {
  filter.value.search = "";

  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

const getData = async () => {
  await productStore
    .getTransferProductLogs(filter.value)
    .then((response) => {
      if (response.status == 200) {
        pagination.value = response.data.data;
      }
    })
    .catch((error) => {
      if (error) {
        console.log("error", error);
      }
    });
};

const debouncedFetch = debounce(getData, 300);

const selectRange = (date) => {
  filter.value.page = "";
  range.value = date;
  if (date != null) {
    filter.value.start_date = $formatDate3(date[0]);
    filter.value.end_date = $formatDate3(date[1]);
  } else {
    filter.value.start_date = "";
    filter.value.end_date = "";
  }
  getData();
};

const handlePage = (page, perpage) => {
  filter.value.page = page;
  filter.value.paginate = perpage;
  getData();
};

const detail = (data) => {
  emit("detail", data);
};

defineExpose({ openModal, closeModal });
</script>

<style lang="scss" scoped>
</style>

<style lang="scss">
.filterBar {
  max-height: 41px;
  cursor: pointer;
  display: flex;
  padding: 10px;
  align-items: center;
  gap: 10px;

  border-radius: 6px 6px 0px 0px;
  border: 1px solid #dfdcdd;
  background: #fff;
  span {
    color: #7c7379;
  }
  &.active {
    border: 1px solid #b7b2b5;
    span {
      color: #1f1d1f;
    }
  }
}
</style>
